/* eslint-disable react/jsx-handler-names */
import cx from "classnames";
import isHTML from "is-html";
import {
  MDBBtn,
  MDBIcon,
  MDBModal,
  MDBModalBody,
  MDBModalFooter,
  MDBModalHeader
} from "mdbreact";
import React, { Fragment } from "react";
import PKHBtn from "~/components/common/atoms/Button";
import partnerId from "~/utils/partner";
import styles from "./style.module.scss";
class Modal extends React.Component {
  static defaultProps = {
    title: "Thông báo",
    iconTitle: null,
    footer: false,
    footerConfirm: false,
    children: "Xảy ra lỗi, Vui lòng thử lại!",
    onOk: () => {},
    okText: "OK",
    openText: "",
    cancelText: "Cancel",
    onCancel: () => {},
    onOpen: () => {},
    centered: false
  };

  toggle = () => {
    this.props.toggle && this.props.toggle();
  };

  handleOk = e => {
    const { onOk } = this.props;
    if (onOk) {
      onOk(e);
    }
  };

  handleCancel = e => {
    const { onCancel } = this.props;
    if (onCancel) {
      onCancel(e);
    }
  };

  handleOpenText = e => {
    const { onOpen } = this.props;
    if (onOpen) {
      onOpen(e);
    }
  };

  renderFooterContent = () => {
    const {
      footerConfirm,
      cancelText,
      okText,
      openText,
      footer,
      okDisabled,
      centerAll
    } = this.props;
    if (footerConfirm) {
      return (
        <MDBModalFooter
          className={cx(styles.modal_footer, centerAll && styles.centerBody)}
        >
          {cancelText && (
            <PKHBtn key="btn-cancel" onClick={this.handleCancel}>
              {cancelText}
            </PKHBtn>
          )}
          {openText ? (
            <PKHBtn
              key="btn-ok"
              confirm="confirm"
              onClick={this.handleOpenText}
            >
              {openText}
            </PKHBtn>
          ) : null}
          {okText && (
            <PKHBtn
              confirm="confirm"
              key="btn-ok"
              onClick={this.handleOk}
              disabled={okDisabled}
            >
              {okText}
            </PKHBtn>
          )}
        </MDBModalFooter>
      );
    } else {
      return (
        <MDBModalFooter className={styles.modal_footer}>
          {footer}
        </MDBModalFooter>
      );
    }
  };

  converContent = children => {
    if (isHTML(children)) {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: children
          }}
        />
      );
    } else {
      return children;
    }
  };

  body = () => {
    const { bannerImage, image, children } = this.props;
    if (bannerImage) {
      return (
        <Fragment>
          <div className={styles.headerClose}>
            <MDBBtn
              onClick={this.toggle}
              className={cx(styles.iconTimes)}
              tag="a"
              size="sm"
              floating
              color="primary"
              gradient="blue"
            >
              <MDBIcon icon="times" />
            </MDBBtn>
          </div>
          <figure>
            <img src={bannerImage} alt="" />
          </figure>
        </Fragment>
      );
    } else if (image) {
      return (
        <figure>
          <img src={image} alt="" />
        </figure>
      );
    } else {
      return this.converContent(children);
    }
  };

  render() {
    const {
      title,
      footer,
      position,
      iconTitle,
      centered,
      fullHeight,
      size,
      modal,
      className,
      backdropClassName,
      bannerImage,
      noBackDrop,
      centerAll
    } = this.props;
    const obj = Object.create(null);
    if (typeof position !== typeof undefined) {
      obj.position = position;
    }
    if (typeof centered !== typeof undefined) {
      obj.centered = centered;
    }
    if (typeof fullHeight !== typeof undefined) {
      obj.fullHeight = fullHeight;
    }
    if (typeof size !== typeof undefined) {
      obj.size = size;
    }
    // const { modal } = this.state
    return (
      <MDBModal
        isOpen={modal}
        toggle={this.toggle}
        {...obj}
        backdrop={noBackDrop}
        className={cx(
          styles.popup_modal,
          styles[className],
          styles["popup_modal_" + partnerId],
          bannerImage && styles.modalImage
        )}
        backdropClassName={styles[backdropClassName]}
      >
        {title && (
          <MDBModalHeader
            toggle={this.props.toggle}
            className={cx(styles.title_popup)}
          >
            {iconTitle}
            {title}
          </MDBModalHeader>
        )}

        <MDBModalBody
          className={cx(
            styles.body,
            centerAll && styles.centerBody,
            bannerImage && styles.bodyImage
          )}
        >
          {this.body()}
        </MDBModalBody>
        {footer ? this.renderFooterContent() : null}
      </MDBModal>
    );
  }
}

export default Modal;
